import { CommonModule } from '@angular/common';
import { afterNextRender, Component, ElementRef, inject, Injector, input, model, output, runInInjectionContext, signal, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UiModule } from '@components/ui/ui-module';
import { CardBinder, TopK } from '@models/binder.model';
import { Card } from '@models/card.model';
import { BinderService } from '@services/binder.service';
import { Card as CardService } from '@services/card.service';

@Component({
  selector: 'lgb-identify-card',
  imports: [
    CommonModule,
    FormsModule,
    UiModule,
  ],
  templateUrl: './identify-card.html',
  styleUrl: './identify-card.css',
})
export class IdentifyCard {
  //services
  readonly cardS=inject(CardService);
  readonly injector = inject(Injector);


  //data
  readonly topK=input.required<TopK[]>();
  readonly topSelected=model.required<TopK>();
  readonly update=output<boolean>();

  //ui
  readonly loading=signal(false);
  readonly action=signal<'match' | 'search'>('match');
  readonly input=viewChild<ElementRef<HTMLInputElement>>('textSearch');

  //search
  readonly searching=signal(false);
  readonly qSearch=signal<string>('');
  readonly results=signal<Card[]>([]);


  getSearchObs(){
    return (q: string, start: number, length: number) => this.cardS.searchCards(q, start, length);
  }

  searchCard(){
    this.action.set('search');
    runInInjectionContext(this.injector, () => {
      afterNextRender(() => {
        this.input()?.nativeElement?.focus();
      });
    });

  }

  selectResult(card: Card){
    this.topSelected.set({
      card,
      score: 0,
      isBest: false,
      isBestFinal: false,
      rank: 0
    });
  }
}
